<template>
  <div id="app" class="app container-fluid">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="scss">
  @import './assets/scss/design.scss';
</style>



// WEBPACK FOOTER //
// App.vue?3489cba8